export default __webpack_public_path__ + "static/agent2-e70e1f90535d229a1fd817981a09bc44.png";